
const getters = {
  getTourResearchForm: state => state.tour.researchForm,
  getTourForm: state => state.tour.form
}

export default getters